import { AvantioService } from "../_services/avantio.service";
import { AvantioStore } from "../_stores/AvantioStore";
import { genericActions } from "./generic.actions"

export const avantioActions = {
    listAccommodations,
}

function listAccommodations(integrationUID: string) {
    return async (dispatch) => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const accommodations = await AvantioService.listAccommodations(integrationUID);
            dispatch(AvantioStore.actionListItemsSuccess(accommodations));
        }
    }
}
